/*************************************************************************
 * 
 * KLEAREXPRESS CONFIDENTIAL
 * __________________
 * 
 *  Copyright (c) 2018 - 2018 KlearExpress Corporation.
 *  All Rights Reserved.
 * 
 * NOTICE:  All information contained herein is, and remains
 * the property of KlearExpress Corporation and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to KlearExpress Corporation
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from KlearExpress Corporation.
 */


import React, { Component } from 'react';
// import '../styles/css/payment-data.css';
import { Form, Header, Grid } from 'semantic-ui-react';

class ACH extends Component {
  constructor() {
    super();
    this.state = {
      values: []
    }
  }
  handleChange = (e, { name, value }) => this.setState({ [name]: value })

  render() {
    const { node, open, ach, creditCard, payPal } = this.state
    const data = this.props
    const style = {
      container: {
        borderRadius: 0,
      },
      radio: {
        fontWeight: '200 !important'
      }
    }

    return (
      <div>
        <div id={this.props.index} className="one-card ach" key={this.props.index} count={this.props.count}>
          <label className="payment-data-label" as="h8">{this.props.data.paymentType}</label>
          <Grid columns={2} divided className="card-grid">

            <Grid.Row>
              <Grid.Column className="payment-cb-col">
                <Form.Group inline>
                  <Form.Checkbox
                    label="Savings"
                    style={style.radio}
                    value='savings'
                    className="payment-data-radio"
                    // checked={value === 'sm'}
                    onChange={this.handleChange}
                  />
                  <Form.Checkbox
                    label='Checking'
                    value='checking'
                    className="payment-data-radio"
                    // checked={value === 'md'}
                    onChange={this.handleChange}
                  />
                </Form.Group>
              </Grid.Column>
              <Grid.Column>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <label className="payment-data-label">NAME ON ACCOUNT</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.fullName}</Header>
              </Grid.Column>
              <Grid.Column>
                <label className="payment-data-label">BANK NAME</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.bankName}</Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <label className="payment-data-label">ACCOUNT NUMBER</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.accountNumber}</Header>
              </Grid.Column>
              <Grid.Column>
                <label className="payment-data-label">ROUTING NUMBER</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.bankRoutingNumber}</Header>
              </Grid.Column>
            </Grid.Row>

            <Grid.Row>
              <Grid.Column>
                <label className="payment-data-label">BANK CITY / STATE</label>
                <br />
                <Header as='h3' className="payment-data-header">{this.props.data.bankLocation}</Header>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </div>
      </div>
    );
  }
}

export default ACH;
